import {apolloClient} from '@/setup/apollo-setup';
import {error, updateItemSuccess} from '@/utils/notification';
import {
  ADD_UPLOAD_YEALINK_IMPORT_DATA, ADD_UPLOAD_YEALINK_LEARN_TIME,
} from '@/queries/modules/yea-link-import-data/yea-link-import-data';

export async function addUploadYeaLinkImportData(context, payload) {
  context.commit('setProcessing', true);
  try {

    const result = await apolloClient
      .mutate({
        mutation: ADD_UPLOAD_YEALINK_IMPORT_DATA,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', updateItemSuccess(data.addUploadYeaLinkImportData.length));

      return data.addUploadYeaLinkImportData
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addUploadYeaLinkLearnTime(context, payload) {
  context.commit('setProcessing', true);
  try {

    const result = await apolloClient
      .mutate({
        mutation: ADD_UPLOAD_YEALINK_LEARN_TIME,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', updateItemSuccess(data.addUploadYeaLinkLearnTime.length));

      return data.addUploadYeaLinkLearnTime
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}
